import bgImage from '../assets/Background.png';

 // === STYLE OPTIONS ===
  const headingFont = "Montserrat, Arial, sans-serif";
  const headingSize = "2.8rem";
  const headingColor = "#ecececff";

  const paraFont = "Lato, Arial, sans-serif";
  const paraSize = "1.22rem";
  const paraColor = "#fbfbfbff";

  // Choose: "flex-start", "center", or "flex-end"
  const verticalAlign = "flex-start";
  // Choose: "flex-start", "center", or "flex-end"
  const horizontalAlign = "center";
  // Set textAlign for text (left/center/right)
  const textAlign = "center";



export default function Contact() {
  return (
    <div
  style={{
    padding: "36px 12px",
    minHeight: "100vh",
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
     justifyContent: verticalAlign,
     alignItems: horizontalAlign
  }}
>

        <h1
  style={{
    fontFamily: headingFont,
    fontSize: headingSize,
    color: headingColor,
    margin: 0,
    textAlign: textAlign
    
  }}
>
  Contact Us
</h1>
      <div style={{ marginTop: 18,  textAlign: textAlign  }}>
  <p
    style={{
      fontFamily: paraFont,
      fontSize: paraSize,
      color: paraColor,
      margin: "0 0 18px 0",
      lineHeight: 1.7
    }}
  >
    Email: Support@uacpakistan.com,    
    UAN: 111 000 000
  </p>
   </div>
    </div>
  );
}
